import logo from './logo.svg';
import './App.css';
import Login from './components/Login';
import Register from './components/Register';

function App() {
  return (
    <div className="App">
      <Login/>
      {/* <Register/> */}
    </div>
  );
}

export default App;
